module.exports = __webpack_public_path__ + "static/media/teo-logov3Blanc-400px.43e9ba2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logov3Blanc-400px.png
// module id = 1867
// module chunks = 0